import React from "react"
import styled from "styled-components"
import homePageData from "../../data/pageSections/home"
import Container from "../layoutComponents/Container"
import H2 from "../typography/H2"
import ImageWrapper from "../layoutComponents/ImageWrapper"
import TextWrapper from "../layoutComponents/TextWrapper"
import Section from "../layoutComponents/Section"

import CheckMark from "../../images/home/check.svg"
import { ListItem, UnorderedList } from "../layoutComponents/UnorderedLists"

const MainFeatures = () => (
  <>
    {homePageData.map(
      ({
        topTitle,
        title,
        description,
        graphic,
        imageLeft,
        benefits,
        link,
        tint,
        clipPath,
        blob,
        imageHalf,
        className,
      }) => (
        <Section
          key={title}
          tint={tint}
          clipPath={clipPath}
          className={className}
        >
          <Container className="power-container">
            <TextWrapper imageLeft={imageLeft}>
              <H2>{title}</H2>
              {description}
              <UnorderedList>
                {benefits &&
                  benefits.map(({ benefitName }) => (
                    <ListItem>
                      <img
                        className="margin-right-10"
                        src={CheckMark}
                        alt="check"
                        title="check"
                      />
                      {benefitName}
                    </ListItem>
                  ))}
              </UnorderedList>
            </TextWrapper>
            <CustomImageWrapper
              className="graphic-image"
              imageLeft={imageLeft}
              blob={blob}
              half={imageHalf}
            >
              {graphic}
            </CustomImageWrapper>
          </Container>
        </Section>
      )
    )}
  </>
)

export default MainFeatures

const CustomImageWrapper = styled(ImageWrapper)`
  ${({ theme }) => theme.desktop`
     picture img {
    top: 50px !important;
    left: 0px !important;
    width: 80% !important; 
    height: 80% !important;
    left: 0% !important;
    right: 0% !important;
    margin: 0 auto !important;
    text-align: center !important;
  }
  
  `}
`
